import { createSlice } from "@reduxjs/toolkit";

const userdetails = {};

const UserDetailsSlice = createSlice({
    name: "userdetails",
    initialState: {
        userdetails,
    },
    reducers: {
        reSetUserDetailsData(state, action){
            state.userdetails = {}
        },
        setUserDetailsData(state, action) {
            state.userdetails = action.payload;
        },
    },
});


export const {
    setUserDetailsData,
    reSetUserDetailsData
} = UserDetailsSlice.actions;

export default UserDetailsSlice.reducer;
